import { Controller } from 'stimulus';

class Filter extends Controller {
  connect() {
    this.controlledBy = document.querySelector(this.data.get('controlled-by'));

    if (!this.controlledBy) {
      throw new Error('Controlled by element is missing');
    }

    this.retrieveActiveFilters();

    this.controlledBy.addEventListener('update', this.onControlledByUpdate.bind(this));
    this.controlledBy.addEventListener('stored', this.onControlledByStored.bind(this));
  }

  disconnect() {
    this.controlledBy.removeEventListener('update', this.onControlledByUpdate.bind(this));
    this.controlledBy.removeEventListener('stored', this.onControlledByStored.bind(this));
  }

  onControlledByUpdate() {
    this.retrieveActiveFilters();
  }

  onControlledByStored() {
    this.filter();
  }

  retrieveActiveFilters() {
    const checkedInputs = Array.prototype.slice.call(
      this.controlledBy.querySelectorAll('input:checked'),
    );

    const activeFilterPills = checkedInputs
      .filter((checkedInput) => checkedInput.value)
      .map((checkedInput) => {
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.textContent = checkedInput.getAttribute('data-label');
        pill.className = 'active-filters__pill';
        pill.setAttribute('data-action', 'click->filter#onFilterDelete');
        pill.setAttribute('data-reference', checkedInput.id);

        return pill;
      });

    this.activeFiltersRowTarget.innerHTML = '';

    this.activeFiltersTarget.style.display = activeFilterPills.length ? 'block' : 'none';

    activeFilterPills.forEach((pill) => {
      this.activeFiltersRowTarget.appendChild(pill);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onFilterDelete(event) {
    const button = event.currentTarget;
    const reference = button.getAttribute('data-reference');
    const referencedElement = document.getElementById(reference);

    if (!referencedElement) {
      return;
    }

    referencedElement.checked = false;
    const changeEvent = new Event('change');
    referencedElement.dispatchEvent(changeEvent);
  }

  filter() {
    $.ajax({
      url: this.data.get('api'),
      complete: (res) => {
        const domParser = new DOMParser();
        const dom = domParser.parseFromString(res.responseText, 'text/html');

        this.outputList(dom);
        this.outputCount(dom);
      },
    });
  }

  outputList(dom) {
    const list = dom.querySelector('[data-target="filter.list"]');

    if (list) {
      this.listTarget.innerHTML = list.innerHTML;
    }
  }

  outputCount(dom) {
    const count = dom.querySelector('[data-target="filter.count"]');

    if (count) {
      this.countTarget.innerHTML = count.innerHTML;
    }
  }
}

Filter.targets = [
  'activeFilters',
  'activeFiltersRow',
  'list',
  'count',
];

export default Filter;
